
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recupera-password/thank-you",
      function () {
        return require("private-next-pages/recupera-password/thank-you.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recupera-password/thank-you"])
      });
    }
  